exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".boldStyle {\n  font-weight: bold; }\n\n.row {\n  width: 100%;\n  display: flex;\n  justify-content: space-between; }\n\n.infoWindowColumnOne {\n  text-align: left; }\n\n.infoWindowColumnTwo {\n  text-align: right;\n  margin: 0px 16px 0px 16px; }\n\n.icon {\n  font-size: small; }\n\n.infoWindow {\n  font-size: x-small;\n  padding-right: 16px; }\n", ""]);

// exports
